import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import ScannerCode from '../../../components/UI/ScannerCode';
import { isNullOrEmpty, translate, showMessageToastCustom } from '../../../utils/util';
import * as volumeAction from '../../../actions/volumeAction';
import VolumeService from '../../../services/VolumeService';
import InputUI from '../../../components/UI/InputUI';

const VolumeRegistration = (props) => {
    const handleOnKeyDown = (e) => {
        if (e.key === 'Enter') {
            scannerRegistration(e.target.value);
        }
    }

    const scannerRegistration = (value) => {
        if (!isNullOrEmpty(value)) {
            if (value.length >= 30) {
                const registration = value.substring(3, 10);
                const el = document.getElementById("txtVolumeRegistration");
                props.getBlockedSerialNumber(registration, () => {
                    props.getVolumeSerialNumber(registration, () => {
                        if (props.volumeRegistrations.filter((f) => f.registration === registration).length >= 1) {
                            showMessageToastCustom(translate('warning', 'general'), translate('registration-already-exists', 'volume'), 3000, 'mdi mdi-alert-circle-outline red-text');
                        }
                        else {
                            props.addVolumeRegistrations({ registration: registration });
                            el.value = "";
                        }
                    })
                });
            } else {
                showMessageToastCustom(translate('warning', 'general'), translate('invalid-registration', 'volume'), 3000, 'mdi mdi-alert-circle-outline red-text');
            }
        }
    };

    return (
        <div className="container">
            <div className="card">
                <div className="card-content" style={{ padding: '0px', paddingTop: '8px' }}>
                    <div className="row">
                        <div className="col s9">
                            <div className="form-group">
                                <div className="input-field">
                                    <i className="material-icons prefix mdi mdi-page-next-outline"></i>
                                    <InputUI
                                        required
                                        type="number"
                                        onKeyDown={handleOnKeyDown}
                                        onBlur={(event) => scannerRegistration(event.target.value)}
                                        id="txtVolumeRegistration"
                                        placeholder={translate('inform-the-enrollment', 'volume')}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col s3 center">
                            <span className="input-group-btn">
                                <button className="btn-floating btn-large btn-principal waves-effect waves-light" type="button">
                                    <ScannerCode className="mdi mdi-barcode-scan posfix disable" onScanner={scannerRegistration} markerCodeBar={true} />
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        config: state.configReducer.config,
        volumeRegistrations: state.volumeReducer.volumeRegistrations
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addVolumeRegistrations: (item) => {
            dispatch(volumeAction.addVolumeRegistrations(item));
        },
        getBlockedSerialNumber: (serialNumber, callback) => {
            dispatch(VolumeService.getBlockedSerialNumber(serialNumber, callback));
        },
        getVolumeSerialNumber: (serialNumber, callback) => {
            dispatch(VolumeService.getVolumeSerialNumber(serialNumber, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VolumeRegistration));
